<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Multiselect from 'vue-multiselect'
import { getFirestore, collection, updateDoc, serverTimestamp, doc, Timestamp  } from "firebase/firestore/lite"
import {firebase} from "../../../../../firebase-int";
import CryptoJS from 'crypto-js';
import axios from 'axios'

const firestore = getFirestore(firebase);
import {
  required,
  email,
  minLength,
  sameAs,
  maxLength,
  minValue,
  maxValue,
  numeric,
  url,
  alphaNum,
} from 'vuelidate/lib/validators'

export default {
  page: {
    title: 'Edit Federation Grievance',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, Multiselect },
  data() {
    return {
      dismissSecs: 2,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      alertMessage:'',
      successStatus:true,
      processingData:false,

      pvtData: "",
      secret: "123#$%",
      encData: "",

      title: 'Edit Federation Grievance',
      items: [
        {
          text: 'Gebi',
          href: '/',
        },
        {
          text: 'Federation Grievance',
          href: '/Grievance-federation',
        },
        {
          text: 'Edit Federation Grievance: '+this.$route.params.grievance.id,
          active: true,
        },
      ],
      status: [
      ],
      stage: [
      ],

      dateOptions: { year: 'numeric', month: 'long', day: 'numeric', hour:'numeric', minute:'numeric', second:'numeric' },


      statusValue:this.$route.params.grievance.status,
      stageValue:this.$route.params.grievance.stage,

      form: {
        subject: this.$route.params.grievance.subject,
        body: this.$route.params.grievance.body,
        created: this.$route.params.grievance.created,
        memberId: this.$route.params.grievance.memberId,
        notes:'',
      },
      submit: false,
      submitted: false,
      formsubmit: false,
      typesubmit: false,

      
      calendarConfig: {
          wrap: true, 
          dateFormat: 'd/m/Y',       
        },
    }
  },
  validations: {
    form: {
      subject: { required,  minLength: minLength(2) },
      body: { required,  minLength: minLength(5) },
      notes: { required},
    },
    
  },
  methods: {
    /**
     * Basic Form submit
     */
    handleSubmit(e) {
      this.submitted = true

      // stop here if form is invalid
      this.$v.$touch();
      if (this.$v.form.$pending || this.$v.form.$error) return;
      this.updateGrievance();
    },

    async updateGrievance() {
      this.processingData=true;
      try {
            const docRef=doc(firestore, 'grievance-federation', this.$route.params.grievance.id)
            
            var currentTime=new Date(Timestamp.now().seconds*1000).toLocaleDateString(undefined, this.dateOptions);
            await updateDoc(docRef, {
              subject: this.form.subject,
              body:this.form.body,
              notes:this.$route.params.grievance.notes+'\n##### Note by: '+this.$store.state.auth.currentUser.id+' // On: '+currentTime+'\n'+this.form.notes+'#####',
              status:this.statusValue,
              stage:this.stageValue,
              //created: serverTimestamp(),
              updated: serverTimestamp(),
              //createdBy: 'Creator User ID',
              updatedBy: this.$store.state.auth.currentUser.id,
            });
            //this.makeToast(false, "Document written with ID: ", docRef.id);
            this.successStatus=true;
            this.dismissSecs=2;
            this.alertMessage="Federation grievance updated with ID: "+ docRef.id;
            this.showAlert();
            console.log("Document written with ID: ", docRef.id);
            await this.addToLog('federation grievance modified', this.$store.state.auth.currentUser.id , docRef.id);
            //this.clearFields();
            setTimeout(() => {
              this.$router.push({ name: 'Federation Grievance' })
            }, 2000)
          } catch (e) {
            console.error("Error updating document: ", e);
            this.successStatus=false;
            this.dismissSecs=4;
            this.alertMessage="Not able to update grievance data. Please try again.";
            this.showAlert();
            this.processingData=false;
          }
          //this.processingData=false;

      },
      clearFields()
      {
        this.form.name= 'Industry Name';
        this.form.description= 'Description goes here';
      },

      // alert related methods
      countDownChanged(dismissCountDown) {
        this.dismissCountDown = dismissCountDown
      },
      showAlert() {
        this.dismissCountDown = this.dismissSecs
      },

      // encryption related methods
      encryptData(passwordData) {
        // return CryptoJS.AES.encrypt(JSON.stringify({ passwordData }), this.secret).toString();
        return CryptoJS.AES.encrypt(passwordData, this.secret).toString();
      },

      gotoGrievances()
      {
        this.$router.push({ name: 'Federation Grievance', params: { userId: '123' } });
      },
      //remove 'Forwarded to Federation' from stages array
      removeItemFromArray()
      {
          const index = this.stage.indexOf('Forwarded to Federation');
          const indexTwo = this.stage.indexOf('Forwarded to CETU');
          if (index > -1) {
            this.stage.splice(index, 1);
          }
          if (indexTwo > -1) {
            this.stage.splice(indexTwo, 1);
          }
      }
      
  },
  async mounted()
  {
    await axios
      .get('/api/gebi/status/all')
      .then((response) => {
        for (let doc of response.data) this.status.push(doc.name)
      })
    await axios
      .get('/api/gebi/stage/all')
      .then((response) => {
        for (let doc of response.data) this.stage.push(doc.name)
      })
      this.removeItemFromArray()
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="row">
      <div class="col-lg-12">
      <b-alert v-if="successStatus" 
      :show="dismissCountDown"
      dismissible
      fade
      variant="success"
      @dismissed="dismissCountDown=0"
      @dismiss-count-down="countDownChanged"
    >
      <p>{{ alertMessage }}</p>
    </b-alert>
    <b-alert v-else 
      :show="dismissCountDown"
      dismissible
      fade
      variant="danger"
      @dismissed="dismissCountDown=0"
      @dismiss-count-down="countDownChanged"
    >
      <p>{{ alertMessage }}</p>
    </b-alert>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="header-title mt-0 mb-1">Grievance Details</h4>
            <p class="sub-header"
              >Enter grievance details here.</p
            >
            <form @submit.prevent="handleSubmit">
              <div class="form-group">
                <label for="subject">
                  Subject
                  <span class="text-danger">*</span>
                </label>
                <input
                  id="subject"
                  v-model="form.subject"
                  name="subject"
                  class="form-control"
                  :class="{ 'is-invalid': submitted && $v.form.subject.$error }"
                  type="text"
                  placeholder="Enter subject"
                  readonly
                />
                <div
                  v-if="submitted && $v.form.subject.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.subject.required"
                    >This value is required.</span
                  >
                  <span v-if="!$v.form.subject.minLength"
                    >Subject must be at least 2 characters.</span
                  >
                </div>
              </div>
              <div class="form-group">
                <label>
                  Body
                  <span class="text-danger">*</span>
                </label>
                <textarea
                  v-model="form.body"
                  type="text"
                  rows="8"
                  name="body"
                  class="form-control"
                  :class="{
                    'is-invalid': submitted && $v.form.body.$error,
                  }"
                  placeholder="Enter body"
                  readonly
                />
                <div
                  v-if="submitted && $v.form.body.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.body.required"
                    >This value is required.</span
                  >
                  <span v-if="!$v.form.body.minLength"
                    >Body must be at least 5 characters.</span
                  >
                </div>
              </div>

              <div class="form-group mt-3 mt-sm-0">
                  <label for="default">Status</label>
                  <multiselect v-model="statusValue" :options="status" :allow-empty="false"></multiselect>
            
              </div>

              <div class="form-group mt-3 mt-sm-0">
                  <label for="default">Stage</label>
                  <multiselect v-model="stageValue" :options="stage" :allow-empty="false"></multiselect>
            
              </div>

              <div class="form-group">
                <label>
                  Notes
                  <span class="text-danger">*</span>
                </label>
                <textarea
                  v-model="form.notes"
                  type="text"
                  rows="8"
                  name="notes"
                  class="form-control"
                  :class="{
                    'is-invalid': submitted && $v.form.notes.$error,
                  }"
                  placeholder="Enter note"
                />
                <div
                  v-if="submitted && $v.form.notes.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.notes.required"
                    >This value is required.</span
                  >
                  <!--span v-if="!$v.form.notes.minLength"
                    >Note must be at least 5 characters.</span
                  -->
                </div>
              </div>

              
            </form>
          </div>
        </div>
        <!-- end card--->
      </div>
      <!-- end col -->

    </div>
    <!-- end row -->

    
    
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
                  
            <!--form @submit.prevent="handleSubmit">
                  <button v-if='!processingData' type="submit" class="btn btn-primary"
                    >Save</button>
                  <button v-else disabled  class="btn btn-primary"
                  >Save</button>
                  <a href="/member">
                  <button class="btn btn-secondary m-l-5 ml-1"
                    >Cancel</button></a>
            </form-->
            <form @submit.prevent="handleSubmit">
            <template>
              <b-button :disabled="processingData" type="submit" variant="primary"><i class="uil uil-down-arrow mr-1"></i>Save Changes</b-button>
              <b-button variant="light" @click="gotoGrievances" style="margin-left:10px;">Close</b-button>
									
								</template>
            </form>
                  
          </div>
        </div>
        <!-- end card--->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->

    
  </Layout>
</template>
